@if (errorMessage) {
  <div class="error-box" [class.withoutIcon]="!showIcon">
    <div class="error-box-body">
      @if (showIcon) {
        <mat-icon class="status-icon">warning</mat-icon>
      }
      <span class="error-box-message">{{errorMessage}}</span>
      @if (errorDetails) {
        <span class="error-box-details">{{errorDetails}}</span>
      }
    </div>
    @if (closebtn) {
      <button class="close-btn" mat-icon-button tabindex="-1" (click)="removeError()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
}
